// Set your preferred login page url, to be used by the functions below
const preferredLoginUrl = "https://elle-sera.com/a/account/login"

// Override to replace all onsite k-hub links (other than teaser)
let updateLoginLinks = function() {
  // Select all <a> tags whose href points to '#k-hub'
  const khubLinks = document.querySelectorAll("a[href$='#k-hub']");

  // Loop through each matching element and update its href to the preferred login page
  khubLinks.forEach(link => {
      link.href = preferredLoginUrl;
  });
}

// Redirect to correct login page
let redirectToOtpLogin = function () {
  // If we're currently on the default Shopify login page, redirect to the preferred login page instead
  if (window.location.href.includes("https://elle-sera.com/account/login")) {
    window.location.replace(preferredLoginUrl);
  }
}

// Run these functions as soon as the page starts loading
updateLoginLinks();
redirectToOtpLogin();
// Run these functions again as soon as the page finishes loading (just in case anything changed)
window.addEventListener('load', () => {
  updateLoginLinks();
  redirectToOtpLogin();
});

